import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_user",
  class: "bg-white",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "userDetail",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "false",
  "data-kt-drawer-width": "{default:'75%', 'md': '45%'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_user_toggle",
  "data-kt-drawer-close": "#kt_drawer_user_close"
}
const _hoisted_2 = {
  class: "card w-100",
  id: "kt_drawer_user_detail"
}
const _hoisted_3 = {
  class: "card-header pe-5",
  id: "kt_drawer_user_detail_header"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center flex-column me-3" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold" }, "Detalle del usuario")
  ])
], -1)
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "me-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "isax-edit-2 text-white fs-2x" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "me-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "isax-trash text-white fs-2x" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-sm btn-icon btn-active-icon-primary",
  id: "kt_drawer_user_close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x" })
], -1)
const _hoisted_13 = {
  class: "card-body",
  id: "kt_drawer_user_detail_body"
}
const _hoisted_14 = {
  class: "scroll-y me-n5 pe-5",
  ref: "messagesRef",
  "data-kt-element": "messages",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-dependencies": "#kt_drawer_user_detail_header",
  "data-kt-scroll-wrappers": "#kt_drawer_user_detail_body",
  "data-kt-scroll-offset": "0px"
}
const _hoisted_15 = { class: "row align-items-center mb-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, "Nombre del usuario")
], -1)
const _hoisted_17 = { class: "col-md-8" }
const _hoisted_18 = { class: "input-group mb-5" }
const _hoisted_19 = { class: "input-group-text text-white" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "row align-items-center mb-12" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, "Correo electrónico")
], -1)
const _hoisted_23 = { class: "col-md-8" }
const _hoisted_24 = { class: "input-group mb-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "@", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "row align-items-center mb-12" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, "Teléfono")
], -1)
const _hoisted_29 = { class: "col-md-8" }
const _hoisted_30 = { class: "input-group mb-5" }
const _hoisted_31 = { class: "input-group-text" }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "row align-items-center mb-12"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, "Ciudad")
], -1)
const _hoisted_35 = { class: "col-md-8" }
const _hoisted_36 = { class: "input-group mb-5" }
const _hoisted_37 = { class: "input-group-text" }
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 1,
  class: "row mb-12"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold align-self-start mb-2" }, "Agencia(s)")
], -1)
const _hoisted_41 = { class: "col-md-8" }
const _hoisted_42 = { class: "input-group-text" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "row align-items-center mb-12" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, "Rol asignado")
], -1)
const _hoisted_46 = { class: "col-md-8 d-flex align-items-center" }
const _hoisted_47 = {
  key: 0,
  class: "input-group mb-5"
}
const _hoisted_48 = { class: "input-group-text" }
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 1,
  class: "input-group"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "Sin rol asignado", -1)
const _hoisted_52 = [
  _hoisted_51
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.$can('Editar usuario'))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "btn btn-sm btn-icon btn-active-icon-primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#newUserModal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editUser(_ctx.userInfo[0])))
                }, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.$can('Eliminar usuario'))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "btn btn-sm btn-icon btn-active-icon-primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#confirmUserDelete",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteUser(_ctx.userInfo[0])))
                }, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_inline_svg, { src: "media/icons/iconsax/user.svg" })
                ]),
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control fs-base",
                  readonly: "",
                  value: _ctx.userInfo[0].name + ' ' + _ctx.userInfo[0].last_name
                }, null, 8, _hoisted_20)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control fs-base",
                  readonly: "",
                  value: _ctx.userInfo[0].email
                }, null, 8, _hoisted_26)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, [
                  _createVNode(_component_inline_svg, { src: "media/icons/iconsax/call.svg" })
                ]),
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control fs-base",
                  readonly: "",
                  value: _ctx.userInfo[0].phone
                }, null, 8, _hoisted_32)
              ])
            ])
          ]),
          (_ctx.userInfo[0].city && _ctx.userInfo[0].id_role_condition === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/map.svg" })
                    ]),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control fs-base",
                      readonly: "",
                      value: _ctx.userInfo[0].city
                    }, null, 8, _hoisted_38)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
              (JSON.stringify(_ctx.userInfo[0].agencies) !== '[]' &&
                _ctx.userInfo[0].id_role_condition === 2) ||
              _ctx.userInfo[0].id_role_condition === 3
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo[0].agencies, (agency) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-group mb-5",
                      key: agency
                    }, [
                      _createElementVNode("span", _hoisted_42, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/shop.svg" })
                      ]),
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control fs-base",
                        readonly: "",
                        value: agency
                      }, null, 8, _hoisted_43)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              (_ctx.userInfo[0].id_role)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/crown-1.svg" })
                    ]),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control fs-base",
                      readonly: "",
                      value: _ctx.userInfo[0].name_role
                    }, null, 8, _hoisted_49)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
            ])
          ])
        ], 512)
      ])
    ])
  ]))
}